import React, { FC } from 'react';
import cls from 'classnames';

import { CardProps, CardVariant } from './Card.types';

const Card: FC<CardProps> & { Variant: typeof CardVariant } = (props) => {
	const { variant = CardVariant.Container, children, className, ...rest } = props;
	return (
		<section {...rest} className={cls('card', variant, className)}>
			{children}
		</section>
	);
};

Card.displayName = 'Card';
Card.Variant = CardVariant;

export default Card;
